import { render, staticRenderFns } from "./BulkOrderCall.vue?vue&type=template&id=70174c8f"
import script from "./BulkOrderCall.vue?vue&type=script&lang=js"
export * from "./BulkOrderCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports